export default __webpack_public_path__ + "static/media/icon-eye-close.0d2b8930.webp";